import {
  BEGIN_FEATURE_FLAG_FETCH,
  END_FEATURE_FLAG_FETCH,
  UPDATE_BULK_FEATURE_FLAG_VALUES,
  UPDATE_FEATURE_FLAG_VALUE,
} from '../constants/actions';

const DEFAULT_FEATURE_FLAG_STATE = {
  key: null,
  fetching: true,
  value: null,
};

const DEFAULT_REDUCER_STATE = {};

const featureFlagReducer = (state = DEFAULT_REDUCER_STATE, action) => {
  const { type, flag, flagsObj, value } = action;

  switch (type) {
    case BEGIN_FEATURE_FLAG_FETCH:
      return {
        ...state,
        [flag]: {
          ...DEFAULT_FEATURE_FLAG_STATE,
          key: flag,
        },
      };
    case UPDATE_BULK_FEATURE_FLAG_VALUES:
      return {
        ...state,
        ...flagsObj,
      };
    case UPDATE_FEATURE_FLAG_VALUE:
      return {
        ...state,
        [flag]: {
          key: flag,
          fetching: false,
          fetched: true,
          value,
        },
      };
    case END_FEATURE_FLAG_FETCH:
      return {
        ...state,
        [flag]: {
          ...state[flag],
          fetching: false,
          fetched: true,
        },
      };
    default:
      return state;
  }
};

export default featureFlagReducer;
